import React, { FC } from "react";
import { ExerciseResult } from "@/components/Trains/model";
import styles from "./ExerciseResults.module.scss";

type ExerciseResultsProps = {
  results: ExerciseResult[];
  exerciseTitle: string;
};

export const ExerciseResults: FC<ExerciseResultsProps> = ({
  results,
  exerciseTitle,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getSuccessIcon = (succeeded: boolean) => {
    return succeeded ? (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={styles.successIcon}>
        <path
          d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={styles.errorIcon}>
        <path
          d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Результаты: {exerciseTitle}</h3>
      <div className={styles.resultsList}>
        {results.map((result, index) => (
          <div key={index} className={styles.resultItem}>
            <div className={styles.resultHeader}>
              <span className={styles.approachNumber}>
                Подход {result.approach_num}
              </span>
              <span className={styles.successIcon}>
                {getSuccessIcon(result.succeced)}
              </span>
            </div>
            <div className={styles.resultDetails}>
              <div className={styles.detailItem}>
                <span className={styles.label}>Повторения:</span>
                <span className={styles.value}>{result.repetitions}</span>
              </div>
              <div className={styles.detailItem}>
                <span className={styles.label}>Вес:</span>
                <span className={styles.value}>{result.weight}</span>
              </div>
              <div className={styles.detailItem}>
                <span className={styles.label}>Дата:</span>
                <span className={styles.value}>{formatDate(result.created_at)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
